import React from 'react'
let cont = 0;
let vector = ['1'];

const Header = function header ({brands,brands_2,categories}){
    return (
    <section>
        <header>
            <div className="container w90 ">
            <a href={https} className="logo">
                <img src={https+"img/logo.svg"} alt="bodubri"/>
            </a>
            <nav className="relative flex">
                <a href={https} className="link">Inicio</a>
                <a href={https+"shop"} className="link openMenu">
                    Productos <img src={https+"img/down.svg"} alt="⬇"/>
                </a>
                <a href={https+"contact"} className="link">Contáctanos</a>
                    <div className="menuDesk flex absolute">
                        <div className="colflex cat1">
                            <h3>Marcas</h3>
                            <div className="flex">
                                <div className="col1 colflex">
                                    {brands.map((b)=>
                                        {
                                            return(
                                                <a href={https+'shop/brand/'+b.id} key={b.id}>{b.name}</a>
                                            )
                                        }
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="colflex cat2">
                            <h3>Categorías</h3>
                            {categories.map((c)=>
                                {
                                    return(
                                        <a href={https+'shop/category/'+c.id} key={c.id}>{c.name}</a>
                                    )
                                }
                            )}
                        </div>
                    </div>
                </nav>
                <div className="actions flex">
                    <div className="searchDesk dnone relative">
                        <img src={https+"img/search.svg"} alt="🔍" className="absolute"/>
                        <input 
                            type="text" 
                            className="searchDesk" 
                            placeholder="Buscar"
                            id="finderProducts"
                        />
                    </div>
                    <hr/>
                    {vector.map((v) => {
                        if(nameUser == null || nameUser == ""){
                            return (
                                <a rel="modal:open" href="#userModal" className="user flex" key="1">
                                    <img src={https+"img/user.svg"} alt="🙍‍♂️"/>
                                    Ingresar
                                </a>
                            )
                        }else{
                            return (
                                <a href={https+'profile'} key="1" className="user flex">
                                    <img src={https+"img/user.svg"} alt="🙍‍♂️"/>
                                    {nameUser}
                                </a>
                            )
                        }
                    })}
                    <hr/>
                    <a href={https+"emptycart"} 
                    className="cartDesktop relative">
                        <img src={https+"img/menuMob/cart.svg"} alt="🛒"/>
                        <span>{cantCart}</span>
                    </a>
                </div>
            </div>
        </header>  
        <div className="sepHome dnone"></div>

        <nav className="navMobile">
            <div className="contNavMob flex w90">
            <a href={https} className="logoMob flex">
                <img src={https+"img/logoMob_2.svg"} alt="bodubri"/>
            </a>
            <a className="loginMob flex" key="1" id="clickProducts">
                <p>Productos</p>
                <img src={https+"img/down_2.svg"}/>
            </a>
            </div>
        </nav>

        <div className="menuMobile flex absolute" id="menuMobile">
            <div className="colflex cat1">
                <h3>Marcas</h3>
                <div className="flex">
                    <div className="col1 colflex">
                        {brands.map((b)=>
                            {
                                return(
                                    <a href={https+'shop/brand/'+b.id} key={b.id}>{b.name}</a>
                                )
                            }
                        )}
                    </div>
                </div>
            </div>
            <div className="colflex cat2">
                <h3>Categorías</h3>
                {categories.map((c)=>
                    {
                        return(
                            <a href={https+'shop/category/'+c.id} key={c.id}>{c.name}</a>
                        )
                    }
                )}
            </div>
        </div>

      </section>
    )
}

export default Header
